import { Box, Grid, useTheme } from "@mui/material";
import {
  addFilledOut,
  setQuickAssessmentFinished,
  useAppDispatch,
  useAppSelector,
  User,
} from "model";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export const NO_PROGRAMM_ID = "QUICK_ASSESSMENT";
export default function Programmes() {
  const theme = useTheme();

  const user = useAppSelector((state) => state.user.details);
  const { programmeId } = useParams<{ programmeId: string }>();

  const quickAssessmentStarted = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    (state) => (state as any).quickAssessmentStarted
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleMessages = (content: any) => {
      if (!content) {
        return;
      }
      // Check if submission is completed.
      if (
        typeof content.data === "object" &&
        content.data.action === "submission-completed"
      ) {
        dispatch(addFilledOut({ filledOutProgrammeId: NO_PROGRAMM_ID }));
        dispatch(setQuickAssessmentFinished(true));
        return;
      }
    };

    if (window.addEventListener) {
      window.addEventListener("message", handleMessages, true); // Capture
    }
    return () => {
      if (window.removeEventListener) {
        window.removeEventListener("message", handleMessages, true);
      }
    };
  }, [dispatch, programmeId]);

  if (quickAssessmentStarted.quickAssessmentStarted) {
    return <>{QuickAssessmentIframe(user)}</>;
  } else {
    return <></>;
  }
}

export const QuickAssessmentIframe = (user: User | undefined) => {
  return (
    <Grid
      item
      xs={12}
      sx={{ flex: 1, display: "flex", flexDirection: "column" }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 0,
          boxShadow: 0,
          padding: 0,
          margin: 0,
          overflow: "hidden",
          flex: 1, // Take remaining space
          display: "flex",
          flexDirection: "row",
          height: "calc(100vh)",
        }}
      >
        <iframe
          frameBorder="0"
          id="JotFormIFrame-251602311826044"
          title="New Customer Registration Form"
          allow="geolocation; microphone; camera; fullscreen; payment"
          src={`https://form.jotform.com/251602311826044?email=${
            user?.mail ?? ""
          }&guid=${user?.guid ?? ""}`}
          style={{
            flex: 1,
            padding: 0,
            margin: 0,
            height: "calc(100vh)",
            width: "100%",
          }}
        ></iframe>
        <script src="https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js"></script>
        <script>
          window.jotformEmbedHandler("iframe[id='JotFormIFrame-251602311826044']",
          "https://form.jotform.com/")
        </script>
      </Box>
    </Grid>
  );
};
